import { useTranslation } from 'react-i18next';

import { Button, Text } from '@fly/core';
import { PlatformInfo } from '@fly/shared';

import { getPlatformIcon } from '../PlatformIcons/PlatformIcons';

interface DownloadButtonsProps {
  detectedConfig: PlatformInfo | null;
  alternativePlatforms: PlatformInfo[];
  onDownload: (config: PlatformInfo) => void;
  className?: string;
}

export function DownloadButtons({
  detectedConfig,
  alternativePlatforms,
  onDownload,
  ...rest
}: DownloadButtonsProps) {
  const { t } = useTranslation();

  return (
    <div {...rest}>
      {detectedConfig && (
        <Button
          size='4'
          color='neutral'
          highContrast
          className='w-fit gap-fly-4'
          onClick={() => onDownload(detectedConfig)}
          iconStart={getPlatformIcon(detectedConfig.platform)}
          data-testid='download-primary'
        >
          <Text size='6' className='font-semibold'>
            {t('app.download.download_button', {
              defaultValue: 'Download',
            })}
          </Text>
        </Button>
      )}
      {alternativePlatforms.length > 0 && !detectedConfig && (
        <div className='gap-3 flex items-start'>
          {alternativePlatforms.map((config) => (
            <Button
              key={config.key}
              size='2'
              color='neutral'
              variant='outline'
              className='gap-fly-3'
              onClick={() => onDownload(config)}
              iconStart={getPlatformIcon(config.platform)}
              data-testid={`download-${config.key}`}
            >
              {config.displayName}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
